function getUserId(user) {
    return Number(user && (user.userId || user.user_id || user.id)) || null;
}

export function isReportAnnulled(report) {
    return Boolean(report && (
        report.is_annulled ||
        (report.annulment && report.annulment.is_annulled)
    ));
}

export function canRequestReportAnnulment(report, user, isAdmin) {
    if (!report || !report.object || isReportAnnulled(report)) {
        return false;
    }
    if (typeof report.can_request_annulment === 'boolean') return report.can_request_annulment;
    if (isAdmin) {
        return true;
    }
    const userId = getUserId(user);
    return Boolean(userId) && [
        report.object.curator_id,
        report.object.main_staff_id
    ].some(id => Number(id) === userId);
}
